export default "__VITE_ASSET__C1hlcN4P__"